import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import { qk } from '@/lib/query-client';

/**
 * Server-driven feature flag for social sign-in (plan D3): GET /api/auth-config
 * is public and lists the providers the server actually has credentials for,
 * so an unconfigured deploy never renders a dead button. Mirrors
 * apps/server/src/routes/api/auth-config.ts.
 */
export interface AuthConfig {
  socialProviders: string[];
}

/**
 * The live social providers. A failed (or still-loading) fetch yields an empty
 * list — the email form must never be blocked on this lookup (plan P3.1).
 */
export function useAuthConfig(): { socialProviders: string[] } {
  const { data } = useQuery({
    queryKey: qk.authConfig,
    queryFn: () => apiFetch<AuthConfig>('/api/auth-config'),
    // Cheap public endpoint; provider config changes require a redeploy.
    staleTime: 5 * 60_000,
  });
  return { socialProviders: data?.socialProviders ?? [] };
}
